import React from 'react';
import { styled } from 'styled-components';
import THEME from '../theme.js';
const Badge = (props) => (React.createElement(StyledBadge, { title: props.title, $color: props.theme ?? THEME.COLOR_PRIMARY, style: props.style, onClick: props.onClick }, props.children));
export default Badge;
const StyledBadge = styled.span `
  padding: 0.2em 0.4em;
  border-radius: 2px;
  font-weight: bold;
  font-size: 0.7em;
  margin-bottom: 0.6em;
  background-color: ${(p) => p.$color};
  color: ${THEME.COLOR_SECONDARY};
  white-space: nowrap;
`;
//# sourceMappingURL=Badge.js.map